import { render, staticRenderFns } from "./shippingInformation.vue?vue&type=template&id=6ddaa6e6&scoped=true&"
import script from "./shippingInformation.vue?vue&type=script&lang=js&"
export * from "./shippingInformation.vue?vue&type=script&lang=js&"
import style0 from "./shippingInformation.vue?vue&type=style&index=0&id=6ddaa6e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddaa6e6",
  null
  
)

export default component.exports